import {UPDATE_NEWS_SORTS, UPDATE_CURRENT_NEWS_SORT_ID, UPDATE_CURRENT_NEWS_SORT_NAME} from 'src/store/mutations-types'
import {sorts} from 'src/api/stadiumApi'
import {isEmpty} from 'src/utils/myUtils'
import {getNewsSortName} from 'src/utils/myNewsSortUtil'

export function updateNewsSorts ({commit, state}) {
  if (state.newsSorts === null || state.newsSorts.length === 0) {
    sorts().then((resp) => {
      commit(UPDATE_NEWS_SORTS, resp)
      refreshCurrentSortInfo(commit, resp, state.currentSortId)
    })
  } else {
    refreshCurrentSortInfo(commit, state.newsSorts, state.currentSortId)
  }
}

export function updateCurrentNewsSortId ({commit, state, dispatch}, sortId) {
  commit(UPDATE_CURRENT_NEWS_SORT_ID, sortId)
  dispatch('updateNewsSorts')
}

export function refreshCurrentSortInfo (commit, sorts, currentSortId) {
  if (isEmpty(currentSortId)) {
    currentSortId = sorts[0].id
    commit(UPDATE_CURRENT_NEWS_SORT_ID, currentSortId)
  }
  let sortName = getNewsSortName(sorts, currentSortId)
  commit(UPDATE_CURRENT_NEWS_SORT_NAME, sortName)
}



// WEBPACK FOOTER //
// ./src/store/action.js